import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import { getCookie } from '../../../utils/helpers';
import { NakedLink } from '../../../utils/NakedLink';
import { emitGAEvent } from '../../../utils/GAUtils';


const useStyles = makeStyles(() => {
  return {
    btnCurvedRed: {
      backgroundColor: '#b31b19',
      display: 'flex',
      flexDirection: 'column',
      color: '#fff',
      fontSize: '22px',
      maxWidth: 'fit-content',
      margin: '20px 0px',
      border: 'none',
      borderRadius: '0px',
      padding: '4px 20px',
      textDecoration: 'none',
      '&:hover': {
        color: '#fff',
        textDecoration: 'none',
      },
    },
    header: {
      margin: 0,
      color: '#fff',
      fontWeight: 'lighter',
    },
    headerBold: {
      margin: 0,
      color: '#fff',
      fontWeight: 'bolder',
      padding: '8px 4px',
      display: 'flex',
      alignItems: 'center',
    },
    alignRight: {
      margin: 'auto 0px 0px auto',
      '@media (max-width: 992px)': { margin: 'auto' },
    },
    hideOnMobile: {
      display: 'block',
      '@media (max-width: 992px)': { display: 'none' },
    },
    hideOnDesktop: {
      display: 'block',
      '@media (min-width: 992px)': { display: 'none' },
    },
  };
});


const DEFAULT_CHECKOUT_URL = '/account/purchase';

function SubscribeCTAButtonV2(props) {
  const partnerCode = getCookie('partnerSource');
  const { title, topText, alignRight, hideOnMobile, link, doNotHide, classNames } = props;
  const classes = useStyles();

  const getUrl = useCallback(() => {
    const baseUrl = new URL(DEFAULT_CHECKOUT_URL, window.location.origin);

    if (title === 'NAKED NEWS LIVE') {
      baseUrl.pathname = '/live';
      baseUrl.searchParams.set('showPaymentPopUp', '1');
    } else if (partnerCode?.length) {
      baseUrl.searchParams.set('promoCode', partnerCode);
    }

    return baseUrl?.pathname?.toString() + baseUrl?.search?.toString();
  }, [title, partnerCode]);
  const url = link || getUrl();

  const emitEvent = useCallback(() => {
    emitGAEvent('CTA Button', title, null, 'click');
  }, [title]);

  if (topText === 'BECOME A') {
    return (
      <NakedLink
        className={
          classnames(
            classes.btnCurvedRed,
            classNames,
            {
              [classes.alignRight]: alignRight,
              [classes.hideOnMobile]: !doNotHide && hideOnMobile,
              [classes.hideOnDesktop]: !doNotHide && !hideOnMobile,

            }
          )
        }
        to={url} onClick={emitEvent}
      >
        <p className={classes.header}>
          <b className={classes.headerBold}>{title}</b>
        </p>
      </NakedLink>
    );
  }

  return (
    <NakedLink
      className={
        classnames(
          classes.btnCurvedRed,
          classNames,
          {
            [classes.alignRight]: alignRight,
            [classes.hideOnMobile]: !doNotHide && hideOnMobile,
            [classes.hideOnDesktop]: !doNotHide && !hideOnMobile,
          }
        )
      }
      to={url} onClick={emitEvent}
    >
      <p className={classes.header}>
        <b className={classes.headerBold}>{title}</b>
      </p>
    </NakedLink>
  );
}

export default SubscribeCTAButtonV2;

SubscribeCTAButtonV2.propTypes = {
  alignRight: PropTypes.bool,
  title: PropTypes.string,
  topText: PropTypes.string,
};

SubscribeCTAButtonV2.defaultProps = {
  title: 'NAKED NEWS',
  alignRight: false,
  hideOnMobile: false,
  doNotHide: false,
};
